
























































































import Vue from 'vue';
import FieldInput from '@/components/form/FieldInput.vue';
import Button from '@/components/form/Button.vue';
import { EmailValidate } from '@/components/form/validate/validate';
import { FormDataInterface, ResponseCodeData } from '@/types';

export default Vue.extend({
  name: 'Recovery',
  components: { FieldInput, Button },
  mounted() {
    const token: string | undefined = this.$route.query['token'] as
      | string
      | undefined;
    if (token) {
      this.activatedMail = true;
      this.token = token;
    }
  },
  methods: {
    validateEmail(): boolean {
      this.resetError();
      let success = true;
      if (!this.email) {
        this.setErrors('email', this.$t('errors.required'));
        success = false;
      }

      if (this.email && !EmailValidate(this.email)) {
        this.setErrors('email', this.$t('errors.incorectEmail'));
        success = false;
      }
      return success;
    },
    validatePassword(): boolean {
      this.resetError();
      let success = true;

      if (!this.password) {
        this.setErrors('password', this.$t('errors.required'));
        success = false;
      }

      if (!this.confirmPassword) {
        this.setErrors('confirmPassword', this.$t('errors.required'));
        success = false;
      }

      if (this.password && this.password.length < this.validateLengthPassword) {
        this.setErrors(
          'password',
          this.$t('errors.minLenghtPassword', {
            count: this.validateLengthPassword,
          })
        );
        success = false;
      }

      if (
        this.confirmPassword &&
        this.confirmPassword.length < this.validateLengthPassword
      ) {
        this.setErrors(
          'confirmPassword',
          this.$t('errors.minLenghtPassword', {
            count: this.validateLengthPassword,
          })
        );
        success = false;
      }

      if (success && this.password !== this.confirmPassword) {
        this.setErrors('confirmPassword', this.$t('errors.notMatchPasswords'));
        success = false;
      }

      return success;
    },
    resetError() {
      this.errors = {
        email: [],
        password: [],
        confirmPassword: [],
      };
    },
    setErrors(field, message) {
      if (!this.errors[field]) return;

      this.errors[field].push(message);
    },
    async submitEmail() {
      if (!this.validateEmail()) return;

      const formData: FormDataInterface = {};
      formData['email'] = this.email;

      const response: ResponseCodeData = await this.$store.dispatch(
        'recovery',
        formData
      );
      if (!response.success) {
        response.data.map((item) => {
          this.errors[item.field]?.push(item.message);
        });
      }
      if (response.statusCode === 204) {
        this.success = true;
      }
    },
    async submitNewPassword() {
      if (!this.validatePassword()) return;

      const formData: FormDataInterface = {};
      formData['password'] = this.password;
      formData['confirm_password'] = this.confirmPassword;
      formData['token'] = this.token;

      const response: ResponseCodeData = await this.$store.dispatch(
        'resetPassword',
        formData
      );
      if (!response.success) {
        response.data.map((item) => {
          this.errors[item.field]?.push(item.message);
        });
      }
      if (response.statusCode === 204) {
        window.location.href = '/';
      }
    },
  },
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      validateLengthPassword: 8,
      errors: {
        email: [] as Array<string>,
        password: [] as Array<string>,
        confirmPassword: [] as Array<string>,
      },
      inputShadow: true,
      success: false,
      activatedMail: false,
      token: '',
    };
  },
});
